/**
 * Mobile Bottom Navigation
 *
 * Shown only on mobile devices (< 768px).
 * Provides quick access to main navigation items.
 */
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import * as Icons from '../icons/Icons';

interface NavItem {
  id: string;
  icon: keyof typeof Icons.Icons;
  path: string;
}

const NAV_ITEMS: NavItem[] = [
  { id: 'home', icon: 'Home', path: '/home' },
  { id: 'dashboard', icon: 'LayoutGrid', path: '/dashboard' },
  { id: 'inbox', icon: 'Inbox', path: '/inbox' },
  { id: 'channels', icon: 'MessageCircle', path: '/channels' },
  { id: 'settings', icon: 'SettingsIcon', path: '/settings' },
];

interface MobileBottomNavProps {
  onNavigate?: () => void;
}

export const MobileBottomNav: React.FC<MobileBottomNavProps> = ({ onNavigate }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavClick = (path: string) => {
    navigate(path);
    onNavigate?.();
  };

  return (
    <nav className="h-16 bg-background-panel/80 backdrop-blur-xl border-t border-black/5 dark:border-white/5 flex items-center justify-around px-4 pb-safe z-40">
      {NAV_ITEMS.map((item) => {
        const IconComponent = Icons.Icons[item.icon];
        const isActive = location.pathname === item.path || location.pathname.startsWith(item.path + '/');

        return (
          <button
            key={item.id}
            onClick={() => handleNavClick(item.path)}
            className={`p-3 rounded-xl transition-all ${
              isActive
                ? 'bg-blue-600 text-white shadow-lg'
                : 'text-slate-500 dark:text-white hover:text-slate-700 dark:hover:text-white'
            }`}
          >
            <IconComponent className="w-5 h-5" />
          </button>
        );
      })}
    </nav>
  );
};

export default MobileBottomNav;
